import { useState, useEffect } from 'react';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const slides = [
    { image: "/circular_after.jpg", label: "Circular driveway — freshly sealed" },
    { image: "/winding_after.jpg",  label: "Winding driveway — Lakes Area job" },
    { image: "/gallery5.jpg",       label: "Estate driveway — Walworth County" },
    { image: "/striping.jpg",       label: "Court striping — commercial work" },
  ];

  useEffect(() => {
    setIsVisible(true);
    const interval = setInterval(() => setCurrentSlide(p => (p + 1) % slides.length), 6000);
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => { clearInterval(interval); window.removeEventListener('scroll', handleScroll); };
  }, []);

  const navLinks = [
    { label: 'Services', href: '#services' },
    { label: 'Our Process', href: '#about' },
    { label: 'Gallery', href: '#gallery' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <>
      {/* Sticky nav - always on top */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-black/90 backdrop-blur-md shadow-lg shadow-black/30' : 'bg-transparent'}`}>
        {/* Orange top bar */}
        <div className="h-1 bg-orange-500 w-full" />
        <div className="px-6 py-3 flex items-center justify-between max-w-7xl mx-auto">
          <a href="#" onClick={() => window.scrollTo({top:0,behavior:'smooth'})}>
            <img src="/logo.png" alt="Lakes Area Sealcoating" className="h-12 md:h-14 object-contain" />
          </a>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-6">
            {navLinks.map(l => (
              <a key={l.label} href={l.href} className="text-white/80 hover:text-white text-sm font-semibold transition-colors">{l.label}</a>
            ))}
            <a href="#contact" className="flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded font-semibold text-sm transition-all border border-white/20">
              <i className="ri-calculator-line"></i>Get Estimate
            </a>
            <a href="tel:262-215-0688" className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded font-semibold text-sm transition-all">
              <i className="ri-phone-fill"></i>(262) 215-0688
            </a>
          </div>

          {/* Mobile hamburger */}
          <button className="md:hidden text-white p-2" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
            <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div className="bg-black/95 backdrop-blur-sm border-t border-white/10 px-6 py-4 flex flex-col gap-4 md:hidden">
            {navLinks.map(l => (
              <a key={l.label} href={l.href} onClick={() => setMenuOpen(false)} className="text-white font-semibold text-lg py-1 border-b border-white/10">{l.label}</a>
            ))}
            <a href="#contact" onClick={() => setMenuOpen(false)} className="flex items-center justify-center gap-2 bg-white/10 text-white px-4 py-3 rounded font-bold mt-1 border border-white/20">
              <i className="ri-calculator-line"></i>Get Free Estimate
            </a>
            <a href="tel:262-215-0688" className="flex items-center justify-center gap-2 bg-orange-500 text-white px-4 py-3 rounded font-bold">
              <i className="ri-phone-fill"></i>(262) 215-0688
            </a>
          </div>
        )}
      </nav>

      {/* Hero section */}
      <section className="min-h-screen flex items-center justify-center relative overflow-hidden">
        {slides.map((slide, i) => (
          <div key={i} className={`absolute inset-0 transition-opacity duration-1000 ${currentSlide === i ? 'opacity-100' : 'opacity-0'}`}>
            <div className="w-full h-full bg-cover bg-center" style={{ backgroundImage: `url('${slide.image}')` }} />
            <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/60 to-black/90" />
          </div>
        ))}

        <div className={`relative z-10 text-center text-white px-6 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="max-w-4xl mx-auto pt-24">
            <div className="flex justify-center mb-4">
              <img src="/logo.png" alt="Lakes Area Sealcoating" className="w-56 md:w-80 lg:w-96 drop-shadow-2xl" />
            </div>
            <div className="inline-flex items-center gap-2 bg-orange-500/20 border border-orange-500/40 text-orange-300 text-sm font-semibold px-4 py-2 rounded-full mb-6 uppercase tracking-widest">
              <i className="ri-shield-check-line"></i>Licensed & Insured · Walworth County, WI
            </div>
            <h1 className="font-display text-4xl md:text-6xl font-bold leading-tight mb-4 uppercase tracking-tight">
              Driveway & <span className="text-orange-500">Commercial</span> Sealcoating
            </h1>
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto mb-8">
              Driveways, parking lots, and striping done right — protecting pavement across the Lakes Area.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-10">
              <a href="tel:262-215-0688" className="flex items-center gap-3 bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded font-bold text-lg transition-all shadow-lg shadow-orange-500/30">
                <i className="ri-phone-fill text-xl"></i>Call Now: (262) 215-0688
              </a>
              <a href="#contact" className="flex items-center gap-3 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white px-8 py-4 rounded font-bold text-lg transition-all border border-white/20">
                <i className="ri-calculator-line text-xl"></i>Get Free Estimate
              </a>
            </div>
            <div className="flex flex-wrap justify-center gap-5 text-sm text-gray-400">
              {['Driveways & Parking Lots','Crack Filling','Lot Striping','Free Estimates','7-Day Availability'].map((t, i) => (
                <div key={i} className="flex items-center gap-2"><i className="ri-check-line text-orange-500"></i>{t}</div>
              ))}
            </div>
          </div>
        </div>
        <div className="absolute bottom-12 left-1/2 -translate-x-1/2 flex space-x-2 z-10">
          {slides.map((_, i) => (
            <button key={i} onClick={() => setCurrentSlide(i)}
              className={`h-1 rounded-full transition-all duration-300 ${currentSlide === i ? 'bg-orange-500 w-8' : 'bg-white/30 w-4'}`} />
          ))}
        </div>
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 animate-bounce z-10">
          <i className="ri-arrow-down-line text-white/50 text-2xl"></i>
        </div>
      </section>
    </>
  );
}
